export const Wired_Mag_Field_XYZ = 'Wired_Mag_Field_XYZ'
export const FlowVis_Digital = 'FlowVis_Digital'
export const Wireless_Liquid_Level_Sensor = 'Wireless_Liquid_Level_Sensor'
export const Single_Wired_Pressure_Sensor = 'Single_Wired_Pressure_Sensor'
export const Dual_Wired_Pressure_Sensor = 'Dual_Wired_Pressure_Sensor'
export const KonaFlow_Digital = 'KonaFlow_Digital'
export const Grow3D_Base_AVC = 'Grow3D_Base_AVC'
export const Grow3D_Sensor_III = 'Grow3D_Sensor_III'
export const Grow3D_Sensor_II = 'Grow3D_Sensor_II'

export const device_type_enum = {
    'Wired Mag Field XYZ': Wired_Mag_Field_XYZ,
    'FlowVis Digital': FlowVis_Digital,
    'KonaFlow Digital': KonaFlow_Digital,
    'Wireless Liquid Level Sensor': Wireless_Liquid_Level_Sensor,
    'Single Wired Pressure Sensor': Single_Wired_Pressure_Sensor,
    'Dual Wired Pressure Sensor': Dual_Wired_Pressure_Sensor,
    'Grow3D Base AVC': Grow3D_Base_AVC,
    'Grow3D Sensor III': Grow3D_Sensor_III,
    'Grow3D Sensor II': Grow3D_Sensor_II
}
